<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': Banner.withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row lg:justify-center items-center px-18px md:px-11 lg:px-50px xl:px-0 pt-10 lg:pt-20 col-span-full md:col-start-1 md:col-end-9 lg:col-start-1 lg:col-end-13 gap-x-88px gap-y-16"
    >
      <section class="w-full lg:w-1/2">
        <p
          class="text-10  md:text-50px"
          v-text="Banner.title"
          :class="Banner.titleStyles"
        />
        <section class="w-100px border-4 border-btn2 rounded-1 mt-7" />
        <p
          class="pt-7 text-lg"
          v-html="
            Banner.text
          "
          :class="Banner.textStyles"
          
        />
        <section class="pt-6" v-if="Banner.firstButton">
          <main-button :text="Banner.buttonText" :class="Banner.btnStyles"  />
        </section>
      </section>

      <section class="w-full lg:w-1/2 max-w-133  " :class="Banner.formStyles || {'border-2 border-black': Banner.formBorder }" >
        <section class=" py-4" :class="{ 'border-b border-black': Banner.formBorder }">
          <p
            class="text-3xl font-semibold"
            v-text="Banner.formTitle"
            :class="Banner.formTitleStyles || { 'text-center': Banner.formBorder }"
          />
        </section>
        <section class="" :class="Banner.inputsContainerStyles">
        <contact-form 
          :buttonTex="Banner.formButtonText" 
          :boxShadow="Banner.inputsBoxShadow" 
          :buttonStyle="Banner.formBntStyles" 
          :submit="Banner.submit" 
          :gRecaptcha="true" 
          :formTermsText="Banner.formTermsText" 
          :landing="landing"
          :buttonText="{
            buttonText:Banner.formButtonText,
            btnText:Banner.displayFormText,
            secondText:Banner.secondText}" 
        />
      
          </section>
          <p class="text-sm pt-2.5" v-text="Banner.formText" v-if="Banner.displayFormText"/>
        </section>
      </section>
  </section>
</template>
<script>

export default {
  components: {
    MainButton: () => import("../components/MainButton.vue"),
    ContactForm: () => import("../components/ContactForm.vue"),
  },
  data: () => ({
    sitekey: process.env.VUE_APP_RECAPTCHA,
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      ip: null,
      town: null,
      country: null,
    },
    isLoading: false,
  }),
  props:{
    withBorder: {
      default: true
    },
    Banner:{
      default: null,
    },
    landing:{}
  },

};
</script>